<!--
* @FileDescription: 日期相关
* @Author: Rocky
* @Date: 2020-07-15
* @LastEditors: Rocky
* @LastEditTime: 2020-07-15
-->
<script>
/**
 * 日期时间转换时间戳
 * @param {string} date 日期字符串
 * @returns {int} 时间戳
 */
function date2stamp (date) {
  var stamp = Date.parse(new Date(date))
  stamp = stamp / 1000
  return stamp
}

/**
 * 时间戳转换年月日
 * @param {int} stamp 时间戳
 * @returns {string} 年月日字符串
 */
function stamp2ymd (stamp) {
  stamp = parseInt(stamp)
  if (stamp.toString().length < 11) {
    stamp = stamp * 1000
  }
  stamp = new Date(stamp)
  var year = stamp.getFullYear()
  var month = stamp.getMonth() + 1
  if (month.toString().length === 1) {
    month = '0' + month.toString()
  }
  var date = stamp.getDate()
  if (date.toString().length === 1) {
    date = '0' + date.toString()
  }
  return year + '-' + month + '-' + date
}

/**
 * 时间戳转日期时间
 * @param {int} stamp 时间戳
 * @returns {string} 日期时间字符串
 */
function stamp2time (stamp) {
  stamp = parseInt(stamp)
  if (stamp.toString().length < 11) {
    stamp = stamp * 1000
  }
  stamp = new Date(stamp)
  var year = stamp.getFullYear()
  var month = stamp.getMonth() + 1
  if (month.toString().length === 1) {
    month = '0' + month.toString()
  }
  var date = stamp.getDate()
  if (date.toString().length === 1) {
    date = '0' + date.toString()
  }
  var hour = stamp.getHours()
  if (hour.toString().length === 1) {
    hour = '0' + hour.toString()
  }
  var minute = stamp.getMinutes()
  if (minute.toString().length === 1) {
    minute = '0' + minute.toString()
  }
  var second = stamp.getSeconds()
  if (second.toString().length === 1) {
    second = '0' + second.toString()
  }
  return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
}

/**
 * GMT 转换 datetime
 * @param {object} gmt GTM时间戳
 * @param {string} type 类型（DT日期和时间，D日期）
 * @returns {string} 日期/时间字符串
 */
function GMT2datetime (gmt, type) {
  type = arguments[1] || 'DT'
  var stamp = new Date(gmt)
  var year = stamp.getFullYear()
  var month = stamp.getMonth() + 1
  if (month.toString().length === 1) {
    month = '0' + month.toString()
  }
  var day = stamp.getDate()
  if (day.toString().length === 1) {
    day = '0' + day.toString()
  }
  var hour = stamp.getHours()
  if (hour.toString().length === 1) {
    hour = '0' + hour.toString()
  }
  var minute = stamp.getMinutes()
  if (minute.toString().length === 1) {
    minute = '0' + minute.toString()
  }
  var second = stamp.getSeconds()
  if (second.toString().length === 1) {
    second = '0' + second.toString()
  }
  var str = year + '-' + month + '-' + day
  if (type === 'T') {
    str += ' ' + hour + ':' + minute + ':' + second
  }
  return str
}

/**
 * 获取当前日期时间
 * @param {string} type 类型（DT日期和时间，D日期，T时间）
 * @returns {string} 日期/时间字符串
 */
function getCurrentDateTime (type) {
  type = arguments[0] || 'DT'
  var stamp = new Date()
  var year = stamp.getFullYear()
  var month = stamp.getMonth() + 1
  var date = stamp.getDate()
  var hour = stamp.getHours()
  if (hour.toString().length === 1) {
    hour = '0' + hour.toString()
  }
  var minute = stamp.getMinutes()
  if (minute.toString().length === 1) {
    minute = '0' + minute.toString()
  }
  var second = stamp.getSeconds()
  if (second.toString().length === 1) {
    second = '0' + second.toString()
  }
  var dateStr = year + '-' + month + '-' + date
  var timeStr = hour + ':' + minute + ':' + second
  if (type === 'DT') {
    return dateStr + ' ' + timeStr
  } else if (type === 'D') {
    return dateStr
  } else {
    return timeStr
  }
}

/**
 * 获取当前时间戳
 */
function getCurrentStamp () {
  var currentDateTime = this.getCurrentDateTime()
  return this.date2stamp(currentDateTime)
}

export default {
  date2stamp, stamp2ymd, stamp2time, GMT2datetime, getCurrentDateTime, getCurrentStamp
}
</script>



// WEBPACK FOOTER //
// src/components/toolkits/dateHelper.vue